<template>
  <div>
    <input type="checkbox"
      :name="name"
      :value="value"
      :checked="isChecked"
      :disabled="disabled"
      @change="updateValue" />
    <span class="checkbox-label">{{ labelText }}</span>
  </div>
</template>

<script>
export default {
  model: {
    prop: 'checked',
  },
  props: {
    name: {
      type: String,
      required: false,
    },
    value: {
      type: Boolean,
    },
    disabled: {
      type: Boolean,
    },
    labelText: {

    },
    checked: {},
  },
  computed: {
    isChecked () {
      return (this.value === this.checked);
    }
  },
  methods: {
    updateValue(e) {
      let value = (e.target.checked);
      this.$emit("input", value);
      this.$emit("change", value);
    }
  }
}
</script>

<style scoped>
.checkbox-label {
  white-space: pre-line;
}
</style>